import settings from "./settings/settings.routes";
import asistenteIA from "./asistente-ia/routes";
import conversation from "./conversation/conversation.routes";
import { routes as searchRoutes } from "../../modules/search/search.routes";
import { routes as contactRoutes } from "./contacts/routes";
import { routes as notificationRoutes } from "./notifications/routes";
import { routes as inboxRoutes } from "./inbox/routes";
import { frontendURL } from "../../helper/URLHelper";
import helpcenterRoutes from "./helpcenter/helpcenter.routes";
import campaignsRoutes from "./campaigns/campaigns.routes";
import crmRoutes from './crm/crm.routes';
import tasksRoutes from './tasks/tasks.routes';
import AppContainer from "./Dashboard.vue";
import Suspended from "./suspended/Index.vue";

export default {
  routes: [
    {
      path: frontendURL("accounts/:accountId"),
      component: AppContainer,
      children: [
        ...inboxRoutes,
        ...conversation.routes,
        ...asistenteIA.routes,
        ...settings.routes,
        ...contactRoutes,
        ...searchRoutes,
        ...notificationRoutes,
        ...helpcenterRoutes.routes,
        ...campaignsRoutes.routes,
        ...crmRoutes.routes,
        ...tasksRoutes.routes,
      ],
    },
    {
      path: frontendURL("accounts/:accountId/suspended"),
      name: "account_suspended",
      meta: {
        permissions: ["administrator", "agent", "custom_role"],
      },
      component: Suspended,
    },
  ],
};
